(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-list-nav-chevrons"] && !Shopify.designMode) return;
  try {
    /* MARCA | 05/06/2026 | Uses select() with current ± 1 to advance one card at a time */
  (function () {
    const chevronBtns = document.querySelectorAll('[data-nav-chevron]');
    chevronBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        const section = btn.closest('.shopify-section');
        if (!section) return;
        const slideshowComponent = section.querySelector('slideshow-component');
        if (!slideshowComponent || typeof slideshowComponent.select !== 'function') return;
        const direction = btn.getAttribute('data-nav-chevron');
        if (direction === 'previous') {
          slideshowComponent.select(slideshowComponent.current - 1, e);
        } else {
          slideshowComponent.select(slideshowComponent.current + 1, e);
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-list-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    function getVisibleTabs(tabList) {
      return Array.prototype.slice.call(tabList.querySelectorAll('[role="tab"]:not([hidden])'));
    }

    function switchTab(tabList, sectionEl, tab) {
      var allTabs = tabList.querySelectorAll('[role="tab"]');
      var allPanels = sectionEl.querySelectorAll('.tabbed-collection-list__panel');

      allTabs.forEach(function (t) {
        t.setAttribute('aria-selected', 'false');
        t.classList.remove('product-list-tabs__tab--active');
      });
      allPanels.forEach(function (p) {
        p.hidden = true;
      });

      tab.setAttribute('aria-selected', 'true');
      tab.classList.add('product-list-tabs__tab--active');

      var panelId = tab.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (panel) {
        panel.hidden = false;
        window.dispatchEvent(new Event('resize'));
      }
    }

    document.addEventListener('click', function (e) {
      var tab = e.target.closest('.product-list-tabs [role="tab"]');
      if (!tab) return;

      var tabList = tab.closest('[role="tablist"]');
      if (!tabList) return;

      var shopifySection = tabList.closest('.shopify-section');
      if (!shopifySection) return;

      var sectionEl = shopifySection.querySelector('[data-tabbed-collection-list]');
      if (!sectionEl) return;

      switchTab(tabList, sectionEl, tab);
    });

    document.addEventListener('keydown', function (e) {
      var tab = e.target.closest('.product-list-tabs [role="tab"]');
      if (!tab) return;

      var tabList = tab.closest('[role="tablist"]');
      if (!tabList) return;

      var visibleTabs = getVisibleTabs(tabList);
      var currentIndex = visibleTabs.indexOf(tab);
      if (currentIndex === -1) return;

      var newIndex;
      if (e.key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % visibleTabs.length;
      } else if (e.key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + visibleTabs.length) % visibleTabs.length;
      } else if (e.key === 'Home') {
        newIndex = 0;
      } else if (e.key === 'End') {
        newIndex = visibleTabs.length - 1;
      }

      if (newIndex !== undefined) {
        e.preventDefault();
        visibleTabs[newIndex].click();
        visibleTabs[newIndex].focus();
      }
    });

    document.addEventListener('click', function (e) {
      var chevronBtn = e.target.closest('[data-nav-chevron]');
      if (!chevronBtn) return;

      var shopifySection = chevronBtn.closest('.shopify-section');
      if (!shopifySection) return;

      var sectionEl = shopifySection.querySelector('[data-tabbed-collection-list]');
      if (!sectionEl) return;

      var activePanel = sectionEl.querySelector('.tabbed-collection-list__panel:not([hidden])');
      if (!activePanel) return;

      var slideshow = activePanel.querySelector('slideshow-component');
      if (!slideshow) return;

      e.stopImmediatePropagation();

      /* MARCA | 27/05/2026 | Fall back to slideshow.previous()/next() for JS-rendered carousels (e.g. recently viewed) that lack internal control buttons */
      var dir = chevronBtn.getAttribute('data-nav-chevron');
      if (dir === 'previous') {
        var prev = slideshow.querySelector('.slideshow-control--previous');
        if (prev) { prev.click(); }
        else if (typeof slideshow.previous === 'function') { slideshow.previous(); }
      } else {
        var next = slideshow.querySelector('.slideshow-control--next');
        if (next) { next.click(); }
        else if (typeof slideshow.next === 'function') { slideshow.next(); }
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    function initSidebarToggle() {
    document.querySelectorAll('.facets--filters-toggle').forEach(function(btn) {
      var sidebarId = btn.getAttribute('aria-controls');
      var sidebar = document.getElementById(sidebarId);
      if (!sidebar) return;

      var wrapper = sidebar.closest('.collection-wrapper');
      var productGrid = wrapper ? wrapper.querySelector('.main-collection-grid') : null;

      function collapse() {
        sidebar.setAttribute('data-sidebar-collapsed', '');
        sidebar.style.display = 'none';
        if (productGrid) productGrid.style.setProperty('grid-column', 'var(--centered)', 'important');
        btn.setAttribute('aria-expanded', 'false');
      }

      function expand() {
        sidebar.removeAttribute('data-sidebar-collapsed');
        sidebar.style.removeProperty('display');
        if (productGrid) productGrid.style.removeProperty('grid-column');
        btn.setAttribute('aria-expanded', 'true');
      }

      if (sidebar.hasAttribute('data-sidebar-collapsed')) collapse();

      btn.addEventListener('click', function() {
        if (sidebar.hasAttribute('data-sidebar-collapsed')) {
          expand();
        } else {
          collapse();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSidebarToggle);
  } else {
    initSidebarToggle();
  }
  } catch(e) { console.error(e); }
})();

})();
